(function () {
  const root = document.querySelector('[data-atd-anim]');
  if (!root) return;

  // Lottie (unchanged)
  const lottieEl = root.querySelector('[data-lottie]');
  const lottieSrc = lottieEl && lottieEl.getAttribute('data-lottie-src');
  function initLottie(){
    if (!window.lottie || !lottieEl || !lottieSrc) return;
    try { window.lottie.loadAnimation({ container:lottieEl, path:lottieSrc, renderer:'svg', loop:true, autoplay:true }); } catch {}
  }
  if (document.readyState === 'complete') initLottie();
  window.addEventListener('load', initLottie);

  // Rotator
  let texts = [];
  try { texts = JSON.parse(root.getAttribute('data-texts') || '[]'); } catch {}
  if (!Array.isArray(texts) || !texts.length) return;

  const interval = parseInt(root.getAttribute('data-interval') || '4000', 10);
  const viewport = root.querySelector('.atd-anim-label__text-viewport');
  let lineCurrent = viewport.querySelector('.atd-anim-label__line.is-current');
  let lineNext    = viewport.querySelector('.atd-anim-label__line.is-next');

  let idx = 0;
  lineCurrent.textContent = texts[idx];
  lineNext.textContent    = texts[(idx + 1) % texts.length];

  function cycle() {
    const nextIdx  = (idx + 1) % texts.length;
    const nextText = texts[nextIdx];

    // Park the next line offscreen (100%)
    lineNext.textContent = nextText;
    lineNext.classList.remove('is-current', 'entering', 'leave-up');
    lineNext.classList.add('is-next');

    // Force the parked state to apply
    // eslint-disable-next-line no-unused-expressions
    lineNext.offsetHeight;

    // Do "leave" in one frame, then "enter" in the next frame
    requestAnimationFrame(() => {
      lineCurrent.classList.add('leave-up');

      requestAnimationFrame(() => {
        lineNext.classList.remove('is-next');
        lineNext.classList.add('entering');

        const dur = 420; // keep in sync with CSS var
        setTimeout(() => {
          // Swap roles without animating the reset
          lineCurrent.classList.add('no-transition');
          lineNext.classList.add('no-transition');

          lineCurrent.className = 'atd-anim-label__line is-next';
          lineNext.className    = 'atd-anim-label__line is-current';

          // Re-enable transitions
          // eslint-disable-next-line no-unused-expressions
          lineCurrent.offsetHeight;
          lineCurrent.classList.remove('no-transition');
          lineNext.classList.remove('no-transition');

          [lineCurrent, lineNext] = [lineNext, lineCurrent];
          idx = nextIdx;

          timer = setTimeout(cycle, interval);
        }, dur);
      });
    });
  }

  let timer = setTimeout(cycle, interval);

  const pause  = () => clearTimeout(timer);
  const resume = () => (timer = setTimeout(cycle, interval));
  root.addEventListener('mouseenter', pause);
  root.addEventListener('mouseleave', resume);
  viewport.addEventListener('focusin', pause);
  viewport.addEventListener('focusout', resume);
})();
